import React from 'react';
import CarouselComponent from 'react-material-ui-carousel';
import { Paper, Box, Typography } from '@mui/material';

const MyCarousel = () => {
  const slides = [
    {

      title: "Shop Smart, Save Big!",
      subtitle: "Exclusive discounts on your favorite grocery items. Don’t miss out!",
      image: "/assets/image/slider1.jpg",  
    },
    {
      title: "Hassle-Free Grocery Shopping",
      subtitle: "Order online and enjoy quick, reliable delivery to your doorstep.",
      image: "/assets/image/slider2.jpg",
    },
    {
      title: "The Freshest Choice Around",
      subtitle: "Premium quality groceries, handpicked for your family’s health and happiness.",
      image: "/assets/image/slider3.jpg",
    }
  ];

  return (
    <Box sx={{ width: '100vw' }}>
      <CarouselComponent
        animation="slide"
        indicators={true}
        swipe={true}
        navButtonsAlwaysVisible={true}
        interval={2000}
      >
        {slides.map((slide, index) => (
          <Paper key={index} sx={{ width: '100%', position: 'relative' }}>
            <Box
              component="img"
              src={slide.image}
              alt={slide.title}
              sx={{
                height: { xs: '500px', md: '100vh' },
                width: '100%',

              }}
            />

            <Box  sx={{position:"absolute", top : '40%', left:"50%", transform:"translate(-50%, -50%)", background :"#4CAF50", padding:"20px 30px", textAlign:"center", borderRadius:"5px", width : {xs : "70%", md : "initial"}}} >
              <Typography sx={{ color:"#fff", fontSize: {xs : '26px', sm : "36px"},  fontWeight:"bold"}}>{slide.title}</Typography>
              <Typography sx={{ color:"#fff", fontSize: {xs : '13px', sm : "18px"},  }}>{slide?.subtitle}</Typography>
            </Box>

          </Paper>
        ))}
      </CarouselComponent>
    </Box>
  );
};

export default MyCarousel;
